import { getTestResults, saveTestResults } from "utils/services/idbService";

export interface DataPointIdList {
    id: number;
    resultId: number;
    valueIds: {
        id: number;
        name: string;
    }[];
}

export interface DataPointAndLocationId {
    dataPointId: string;
    locationId: number;
}

export async function updateCachedDataPointIDs(databaseToCachedIDMap: Map<DataPointAndLocationId, DataPointIdList>) {

    if (databaseToCachedIDMap.size === 0) {
        return;
    }

    //Update the cache all at once after all API calls are done
    let cachedData = await getTestResults(
        `allSites`,
        localStorage.getItem('currentUser') ?? 'unknown'
    );

    let cachedLocations: any[] = [];
    cachedData.forEach((site: any) => {
        site.sampleLocationAllVOs.forEach((location: any) => {
            cachedLocations.push(location);
        })
    });

    databaseToCachedIDMap.forEach((databaseIds, cacheIdentifiers, map) => {
        let location = cachedLocations.find((location: { id: any; }) => location.id === cacheIdentifiers.locationId);
        let dataPoint = location.dataPointAllVOs.find((dataPoint: { id: any; }) => dataPoint.id === cacheIdentifiers.dataPointId);

        if (dataPoint) {
            dataPoint.id = databaseIds.id;
            dataPoint.resultId = databaseIds.resultId;
            dataPoint.valueVOs.forEach((cacheValue: { outputId: any; id: any; }) => {
                let databaseValue = databaseIds.valueIds.find((value) => value.name === cacheValue.outputId);
                cacheValue.id = databaseValue?.id ?? 0;
            })
        }
    })

    await saveTestResults(
        `allSites`,
        cachedData,
        localStorage.getItem('currentUser') ?? 'unknown'
    );

    return cachedData;
    
}

export function gatherDatabaseIDs(databaseResult: any): DataPointIdList {

    let valueIds = [] as any[];

    databaseResult?.testKitMeasurementResultVOs[0]?.testKitMeasurementResultValueVOs.forEach(
        (valueVO: any) => {
            let valueId = {
                id: valueVO.id,
                name: valueVO.name,
            }
            valueIds.push(valueId);
        }
    );

    let ids = {
        id: databaseResult?.id ?? 0,
        resultId: databaseResult?.testKitMeasurementResultVOs[0]?.resultId ?? 0,
        valueIds: valueIds,
    }

    return ids;

}